// Function to convert Persian and Arabic digits to English digits
const convertDigitsToEnglish = (str) => {
    if (!str) return str;
    
    const persianNumbers = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    const arabicNumbers = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    
    let result = str;
    
    // Convert Persian digits
    for (let i = 0; i < persianNumbers.length; i++) {
        result = result.replace(new RegExp(persianNumbers[i], 'g'), englishNumbers[i]);
    }
    
    // Convert Arabic digits
    for (let i = 0; i < arabicNumbers.length; i++) {
        result = result.replace(new RegExp(arabicNumbers[i], 'g'), englishNumbers[i]);
    }
    
    return result;
};

export default function TextField({item}){
    return (
        <div className={`w-full`}>
            <div className={`text-13`}>{item.label}</div>
            <input onKeyUp={ (e) => {
                const convertedValue = convertDigitsToEnglish(e.target.value);
                e.target.value = convertedValue;
                item.value = convertedValue;
            } } defaultValue={item.value} className={`w-full`} type={`text`}/>
        </div>
    )
}